<template>
  <div class="login">
    <form v-on:submit.prevent="onSubmit()" class="form-horizontal">
      <div class="form-group">
        <img :src="'/static/icons/BaanRueJai.svg'" class="logo" />
      </div>
      <div class="form-group">
        <div class="col-md-4 offset-md-4 col-12">
          <input
            v-validate="'required|email'"
            name="email"
            type="text"
            autocomplete="username"
            class="form-control"
            :class="{ error: errors.has('email') | error }"
            :placeholder="$t('feature.login.email')"
            v-model="email"
          />
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-4 offset-md-4 col-12">
          <input
            v-validate="'required|min:6'"
            type="password"
            autocomplete="current-password"
            class="form-control"
            :class="{ error: errors.has('password') | error }"
            name="password"
            id=""
            :placeholder="$t('feature.login.password')"
            v-model="password"
          />
          <div class="alert-error" style="" v-if="error">
            <i class="fa fa-info-circle"></i>
            {{ $t("feature.login.invalid") }}
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-4 offset-md-4 col-12">
          <button type="submit" class="btn btn-primary btn-block text-white">
            {{ $t("feature.login.label") }}
          </button>
        </div>
      </div>
      <div>
        <small class="version label">{{ $t("version") }} {{ version }}</small>
      </div>
    </form>
  </div>
</template>

<script>
import { version } from "@/../package.json";
import { baanRueJaiClient } from "@/dependencies";

export default {
  data() {
    return {
      email: "",
      password: "",
      error: false,
      version
    };
  },
  methods: {
    onSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$http
            .post(`${process.env.HOST}/api/admin/auth/login`, {
              email: this.email,
              password: this.password
            })
            .then(
              response => {
                baanRueJaiClient.setAuthorizationToken(
                  response.body.accessToken
                );
                localStorage.setItem("accessToken", response.body.accessToken);
                localStorage.setItem(
                  "refreshToken",
                  response.body.refreshToken
                );
                this.$http
                  .get(`${process.env.HOST}/api/admin/auth/`, {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem(
                        "accessToken"
                      )}`
                    }
                  })
                  .then(res => {
                    localStorage.setItem("adminFirstName", res.body.firstName);
                    localStorage.setItem("adminLastName", res.body.lastName);
                    localStorage.setItem("adminRole", res.body.role);
                    localStorage.setItem(
                      "adminRolePermission",
                      JSON.stringify(res.body.adminRole)
                    );
                    localStorage.setItem(
                      "adminRoleId",
                      res.body.adminRole.roleId
                    );
                    localStorage.setItem("adminId", res.body.adminId);
                    localStorage.setItem(
                      "adminProjects",
                      res.body.adminProjects
                        .map(project => project.projectId)
                        .join()
                    );
                    if (this.$route.query.redirect !== undefined) {
                      this.$router.push({ path: this.$route.query.redirect });
                    } else {
                      this.setDefaultRouteByPermission(res.body.adminRole);
                    }
                  });
              },
              response => {
                if (response.status !== 200) {
                  this.error = true;
                }
              }
            )
            .catch(e => {
              throw e;
            });
        }
      });
    },
    setDefaultRouteByPermission(permission = null) {
      if (permission && permission.features) {
        const firstFeature = permission.features[0];

        switch (firstFeature.featureId) {
          case 1:
            this.$router.push({
              name: "ArticleList",
              params: { articleType: "news" }
            });
            break;
          case 2:
            this.$router.push({
              name: "ArticleList",
              params: { articleType: "activities" }
            });
            break;
          case 3:
            this.$router.push({
              name: "ArticleList",
              params: { articleType: "privileges" }
            });
            break;
          case 4:
            this.$router.push({ name: "ContactProject" });
            break;
          default:
            this.$router.push({ name: "Dashboard" });
        }
      } else {
        this.$router.push({ name: "Dashboard" });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.form-control {
  box-shadow: none;
  border: none;
  border-bottom: solid 0.5px #4a4a4a;
  border-radius: 0px;
  font-size: 17px;
}
.form-control:hover,
.form-control:focus {
  box-shadow: none;
  border-bottom: solid 0.5px #4a4a4a;
}
.form-control.error {
  border-bottom: solid 1.5px #d0021b;
}
.form-group {
  margin-bottom: 25px;
}
body {
  background-color: #fff;
}
.login {
  margin: 5%;
}
.logo {
  margin: 25px;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
input,
button,
select,
textarea {
  height: 45px;
}
.alert-error {
  margin-top: 5px;
  color: #d0021b;
  text-align: right;
  font-size: 13px;
}
.version {
  color: #8c8786;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/Login.vue